import { isNumber } from '@agilepoint/utils-common';
import { IDateFormat } from '@agilepoint/utils-date-time';
import { IMaskInfo } from '../masked-input';

const dateMasks: IMaskInfo[] = [
    {
        pattern: '[0-3]',
        placeholder: 'd'
    },
    {
        pattern: '[0-9]',
        placeholder: 'd',
        validate: (key, value, maskInfo) => {
            const inputDigit = Number(key);
            if (!isNumber(inputDigit)) {
                return false;
            }
            const prevDigit = value.substring(maskInfo.startIndex - 1, maskInfo.startIndex);
            return Number(prevDigit) < 3 || inputDigit < 2;
        }
    }
];

const monthNumberMasks: IMaskInfo[] = [
    {
        pattern: '[0-1]',
        placeholder: 'M'
    },
    {
        placeholder: 'M',
        validate: (key, value, maskInfo) => {
            const inputDigit = Number(key);
            if (!isNumber(inputDigit)) {
                return false;
            }
            const prevDigit = value.substring(maskInfo.startIndex - 1, maskInfo.startIndex);
            return Number(prevDigit) === 0 || inputDigit < 3;
        }
    }
];

const monthNameMasks: IMaskInfo[] = [
    {
        pattern: '[a-zA-Z]',
        placeholder: 'M',
        transform: (val) => val.toUpperCase()
    },
    {
        pattern: '[a-zA-Z]',
        placeholder: 'M'
    },
    {
        pattern: '[a-zA-Z]',
        placeholder: 'M'
    }
];

const yearMasks: IMaskInfo[] = [
    {
        pattern: '[0-9]',
        placeholder: 'y'
    },
    {
        pattern: '[0-9]',
        placeholder: 'y'
    },
    {
        pattern: '[0-9]',
        placeholder: 'y'
    },
    {
        pattern: '[0-9]',
        placeholder: 'y'
    }
];

const getSeparatorMask = (separator: string): IMaskInfo => ({
    fixedContent: separator,
    placeholder: separator
});

const masksByFormatMap = new Map<IDateFormat, IMaskInfo[]>();

masksByFormatMap.set('MM/dd/yyyy', [...monthNumberMasks, getSeparatorMask('/'), ...dateMasks, getSeparatorMask('/'), ...yearMasks]);
masksByFormatMap.set('MMM dd yyyy', [...monthNameMasks, getSeparatorMask(' '), ...dateMasks, getSeparatorMask(' '), ...yearMasks]);
masksByFormatMap.set('dd MMM yyyy', [...dateMasks, getSeparatorMask(' '), ...monthNameMasks, getSeparatorMask(' '), ...yearMasks]);
masksByFormatMap.set('dd.MM.yyyy', [...dateMasks, getSeparatorMask('.'), ...monthNumberMasks, getSeparatorMask('.'), ...yearMasks]);
masksByFormatMap.set('dd/MM/yyyy', [...dateMasks, getSeparatorMask('/'), ...monthNumberMasks, getSeparatorMask('/'), ...yearMasks]);
masksByFormatMap.set('ddMMyyyy', [...dateMasks, ...monthNumberMasks, ...yearMasks]);
masksByFormatMap.set('yyyy-MM-dd', [...yearMasks, getSeparatorMask('.'), ...monthNumberMasks, getSeparatorMask('.'), ...dateMasks]);

export const getMasksByFormat = (format: IDateFormat): IMaskInfo[] => (masksByFormatMap.get(format) ?? masksByFormatMap.get('dd/MM/yyyy')!);
